import { useEffect, useMemo, useState } from "react";
import { Button, Form } from "react-bootstrap";

import { faMinus, faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { FormControlWrapper } from "./formControlWrapper";

export const FieldJsonDict = ({
	fieldData = { "": "" },
	initialData = { "": "" },
	placeholder = ["", ""],
	isDisabled = false,
	error = "",
	autoFocus = false,
	setValue = () => {},
}: {
	fieldData?: any;
	initialData?: any;
	placeholder?: [string, string];
	isDisabled?: boolean;
	error?: string;
	autoFocus?: boolean;
	setValue?: CallableFunction;
}) => {
	let entries = Object.entries(fieldData);
	if (JSON.stringify(entries) === '[["",""]]')
		entries = Object.entries(initialData);
	const [dictEntries, setDictEntries] = useState(entries as [string, any][]);
	const [currentError, setError] = useState(error);

	const addEntry = () => {
		setDictEntries((prevDict: [string, any][]) => {
			return [...prevDict, ["", ""]];
		});
	};

	const setDictEntryKey = (idx: number, key: string) => {
		const newDict = [...dictEntries];
		dictEntries[idx][0] = key;
		setDictEntries(newDict);
	};

	const setDictEntryValue = (idx: number, value: string) => {
		const newDict = [...dictEntries];
		dictEntries[idx][1] = value;
		setDictEntries(newDict);
	};

	const delDictEntry = (idx: number) => {
		dictEntries.splice(idx, 1);
		setDictEntries([...dictEntries]);
	};

	useEffect(() => {
		setValue(Object.fromEntries(new Map(dictEntries)));
	}, [dictEntries]);

	const items = useMemo(() => {
		try {
			return (
				<div data-testid="test-fieldJsonDictEntriesContainer">
					{dictEntries?.map((item, idx) => (
						<div key={idx} className="d-flex">
							<Form.Control
								className="p-1"
								disabled={isDisabled}
								value={item[0]}
								maxLength={100}
								isInvalid={!!error}
								placeholder={placeholder[0]}
								onChange={(e) =>
									setDictEntryKey(idx, e.target.value)
								}
								autoFocus={autoFocus}
							/>
							<Form.Control
								className="p-1"
								disabled={isDisabled}
								value={item[1]}
								maxLength={100}
								isInvalid={!!error}
								placeholder={placeholder[1]}
								onChange={(e) =>
									setDictEntryValue(idx, e.target.value)
								}
							/>
							<Button
								onClick={() => delDictEntry(idx)}
								variant="primary"
								size="sm"
								aria-label="Delete"
							>
								<FontAwesomeIcon icon={faMinus} />
							</Button>
						</div>
					))}
				</div>
			);
		} catch (ex: any) {
			setError(ex.message);
		}
	}, [fieldData, dictEntries]);

	return (
		<FormControlWrapper
			data-testid="test-fieldJsonDict"
			error={currentError}
		>
			{items}
			<Button
				onClick={addEntry}
				variant="outline-primary"
				size="sm"
				aria-label="Add"
			>
				<FontAwesomeIcon icon={faPlus} />
			</Button>
		</FormControlWrapper>
	);
};
